export default __webpack_public_path__ + "static/media/640_business06-it-mobile.e29aebdc.png";